import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, message, Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { apiService } from "@/services/api";

export const TypeEdit: React.FC = () => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!id) return;
      try {
        const data = await apiService.getContentTypes();
        const type = (data as any[]).find(
          (t: any) => String(t.id) === String(id)
        );
        if (type) {
          form.setFieldsValue({ title: type.title });
        }
      } catch (e) {
        message.error("Impossible de charger le type");
      } finally {
        setFetchLoading(false);
      }
    })();
  }, [id]);

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      await apiService.updateType(Number(id), { title: values.title });
      message.success("Type de contenu mis à jour");
      navigate("/types");
    } catch (e: any) {
      message.error("Erreur lors de la mise à jour");
    } finally {
      setLoading(false);
    }
  };

  if (fetchLoading) return <Spin />;

  return (
    <Card title={`Modifier le type #${id}`}>
      <Form layout="vertical" form={form} onFinish={onFinish} style={{ maxWidth: 500 }}>
        <Form.Item
          label="Titre"
          name="title"
          rules={[{ required: true, message: "Le titre est requis" }]}
        >
          <Input placeholder="Ex: Film, Série, Documentaire..." />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Enregistrer
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate("/types")}>
            Annuler
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default TypeEdit;
